import { createFileRoute } from "@tanstack/react-router";
import ElectricalServicesOverview from "@/pages/ElectricalServicesOverview";
import { hubHead } from "@/lib/route-seo";

export const Route = createFileRoute("/electrical-services/")({
  head: () => hubHead("/electrical-services"),
  component: ElectricalServicesOverview,
});
